import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { EyeOff } from "lucide-react";
import { label } from "../../lib/api";
import { InfoTip } from "./InfoTip";


const Tip = ({ active, payload, unit }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-md bg-stone-900 px-3 py-2 text-xs text-amber-50">
      <p className="font-semibold">{d.name}</p>
      <p>{d.count} {unit} · {d.pct}%</p>
    </div>
  );
};

export const DistChart = ({ title, dist, tip, testId }) => {
  if (!dist) return null;
  const shown = dist.items.filter((i) => i.count !== null).map((i) => ({ ...i, name: label(i.key) }));
  const hidden = dist.items.filter((i) => i.suppressed);
  return (
    <div className="rounded-xl border border-amber-700/15 bg-white p-5 sm:p-6" data-testid={testId}>
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-base font-semibold text-stone-800">{title}</h3>
        {tip && <InfoTip text={tip} testId={`${testId}-tip`} />}
      </div>
      <p className="mt-1 text-xs text-stone-500">
        % of {dist.answered} answering {dist.unit === "individuals" ? "households (counts are people)" : "households"}
        {dist.multiple_answers ? " · more than one answer allowed" : ""}
      </p>
      <div className="mt-4" style={{ height: Math.max(140, shown.length * 34) }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={shown} layout="vertical" margin={{ left: 8, right: 24 }}>
            <XAxis type="number" domain={[0, 100]} hide />
            <YAxis type="category" dataKey="name" width={130} tick={{ fontSize: 12, fill: "#44403C" }} />
            <Tooltip content={<Tip unit={dist.unit} />} cursor={{ fill: "rgba(217,119,6,0.08)" }} />
            <Bar dataKey="pct" fill="#92400E" radius={[0, 4, 4, 0]} label={{ position: "right", fontSize: 11, fill: "#57534E", formatter: (v) => `${v}%` }} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-3 flex flex-wrap gap-2 text-xs">
        {hidden.map((h) => (
          <span key={h.key} className="inline-flex items-center gap-1 rounded-full bg-stone-100 px-2 py-1 text-stone-500">
            <EyeOff className="h-3 w-3" /> {label(h.key)}: hidden (fewer than 5)
          </span>
        ))}
        <span className="rounded-full bg-amber-50 px-2 py-1 text-amber-900" data-testid={`${testId}-missing`}>
          Not answered: {dist.missing} households
        </span>
      </div>
    </div>
  );
};
